// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.renewal.LeaseRenewalWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateLeaseRenewalWebApiRequestDto,
  CreateLeaseRenewalWebApiResponseDto,
  GetLeaseExtensionWebApiResponseDto,
} from '../..';

interface GetLeaseExtensionParams {
  leaseExtensionId: number;
}

export const LeaseRenewalWebApiHandler_create_Path = '/api/web/v1/lease/renewal/create';

/**
 * create new lease renewal
 */
export const LeaseRenewalWebApiHandler_create = (
  postData: CreateLeaseRenewalWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateLeaseRenewalWebApiRequestDto, CreateLeaseRenewalWebApiResponseDto>(
    {
      endpoint: LeaseRenewalWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseRenewalWebApiHandler_getLeaseExtension_Path = '/api/web/v1/lease/renewal/getLeaseExtension';

/**
 * get lease extension
 */
export const LeaseRenewalWebApiHandler_getLeaseExtension = (
  getParams: GetLeaseExtensionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLeaseExtensionParams, never, GetLeaseExtensionWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseRenewalWebApiHandler_getLeaseExtension_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
